import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { VerificationCustomerService } from '@api/verification-customer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-verification-customer-info',
  templateUrl: './verification-customer-info.component.html',
  styleUrls: ['./verification-customer-info.component.scss']
})
export class VerificationCustomerInfoComponent implements OnInit {
  public destroy$ = new Subject<void>();
  verificationCustomerInfo;
  verificationCustomerId;
  verificationCustomerForm: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private verificationCustomerService: VerificationCustomerService,
    private formBuilder: FormBuilder,

  ) {
    this.verificationCustomerForm = this.formBuilder.group({
      economicCodeStatus: [0, []],
      nationalCodeStatus: [0, []],
      registrationNumberStatus: [0, []],
      companyNameStatus: [0, []],
    });
  }

  ngOnInit(): void {
    this.verificationCustomerId = this.activatedRoute.snapshot.params.id;
    this.verificationCustomerService.getVerificationCustomerById(this.verificationCustomerId).pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.verificationCustomerInfo = res;
        this.verificationCustomerForm.patchValue({
          economicCodeStatus:
            this.verificationCustomerInfo.economicCode?.status,
          nationalCodeStatus:
            this.verificationCustomerInfo.registrationNumber?.status,
          registrationNumberStatus:
            this.verificationCustomerInfo.companyNationalCode?.status,
          companyNameStatus:
            this.verificationCustomerInfo.clearanceCommunityLicenseImage?.status
        });
      });
  }

  saveVerificationCustomer() {
    const data = {
      economicCodeStatus: +this.verificationCustomerForm.get('economicCodeStatus').value,
      nationalCodeStatus: +this.verificationCustomerForm.get('nationalCodeStatus').value,
      registrationNumberStatus: +this.verificationCustomerForm.get('registrationNumberStatus').value,
      companyNameStatus: +this.verificationCustomerForm.get('companyNameStatus').value,
    }
    this.verificationCustomerService.updateVerificationCustomer(this.verificationCustomerId, data)
      .subscribe((res) => console.log(res));
  }
}
